export default __webpack_public_path__ + "static/media/il_notaccepted.12e0eca7.png";